import { createFileRoute } from "@tanstack/react-router";

import CreateLead from "@/pages/CreateLead";
import { COUNTRY_PRODUCT_IDs } from "@/utils/constants";

export const Route = createFileRoute("/_authenticated/lead/create")({
  component: () => {
    return <CreateLead countryProductId={COUNTRY_PRODUCT_IDs.CREDIT_CARD} />;
  },
});
